<template>
  <div>
    <v-progress-circular color="primary" indeterminate v-if="loading"></v-progress-circular>
    <div v-show="!showPrintPreview && !loading">


      <clipper-fixed
          preview="preview"
          ref="clipper"
          :area="clipperArea"
          :ratio="ratio"
          :grid="false"
          shadow="rgba(0,0,0,0.6)"
          :rotate="rotation"
          :src="imgURL"
          :round="round"
          @load="imgLoad"
          @error="imgLoadError"
          :handle-zoom-event="handleZoomEvent"
          :overlay-image="overlayImage"
          :border="border"
          :min-scale="0.6"
      >
      </clipper-fixed>



      <div class="my-6">
        <v-slider
            v-if="imgLoaded"
            min="-180"
            max="180"
            v-model="rotation"
            label="Drehen"
            prepend-icon="mdi-rotate-right"
            color="secondary"
            @click:prepend="rotate"
        >

        </v-slider>

        <clipper-upload
            class="v-btn v-btn--contained v-btn--rounded secondary buttonColor--text v-size--large ma-2"
            style="cursor: pointer"
            v-model="imgURL"
            accept="image/*"
            @input="onClipperUploadInput"
        >
          <v-icon left color="buttonColor">mdi-camera</v-icon>{{ imgLoaded ? "Anderes Foto wählen" : "Foto auswählen" }}
        </clipper-upload>


        <!--      <v-btn class="ma-2"  @click="rotate">-->
        <!--        <v-icon>mdi-rotate-right</v-icon>-->
        <!--        Drehen-->
        <!--      </v-btn>-->

        <v-btn v-if="imgLoaded" rounded large @click="getCroppedImage" class="secondary buttonColor--text" >Weiter<v-icon right>mdi-arrow-right</v-icon></v-btn>
      </div>


    </div>

    <div class="mb-5" v-show="resultURL && showPrintPreview">

<!--      <div v-if="isUploading" class="my-5">-->
<!--        <v-progress-linear-->
<!--            v-model="uploadPercentage"-->
<!--            color="primary"-->
<!--        ></v-progress-linear>-->
<!--        <div>Lade hoch: {{ uploadPercentage }} %</div>-->
<!--      </div>-->


      <div class="mb-5">Vorschau</div>

      <div v-if="isLowQuality" class="warning pa-2 my-3"><v-icon left>mdi-alert</v-icon>
        Achtung: Bild hat eine geringe Auflösung
      </div>
      <div style="position: relative" class="croppedImage">
        <div style="">
          <img class="result" style="" :src="resultURL" >
        </div>

        <!-- when disabled -> clippo.js -> draw overlay there -->
<!--        <div class="overlayImage" style="position: absolute; left:0; top:0;" width="100%">-->
<!--&lt;!&ndash;          <img class="result" width="100%" :src="overlayImage">&ndash;&gt;-->
<!--          <img class="result" width="100%" src="img/onlineoverlay-white-bg.png">-->
<!--        </div>-->


        <div class="my-5"  style="position: absolute; bottom: 0; left: 0;">
          <v-btn fab small @click="goBack" class="secondary">
            <v-icon icon color="buttonColor">mdi-pencil</v-icon>
          </v-btn>
          <!--        <v-btn  class="primary ma-3">OK, weiter-->
          <!--        </v-btn>-->
        </div>

      </div>




    </div>
  </div>
</template>

<script>
// import {clipperFixed, clipperUpload} from 'vuejs-clipper'
import {clipperFixed, clipperUpload} from '@/plugins/clipper/clipper'

export default {
  name: "ImageClipper",
  components: {
    clipperFixed,
    // clipperPreview,
    clipperUpload
  },
  props: [
    'overlayImage',
  ],
  data: () => ({
    loading: false,
    imgURL: null,
    resultURL: '',
    scale: 1,
    rotation: 0,
    ratio: 1,
    round: true,
    border: 0,
    clipperArea: 90,
    maxWidth: 300,
    maxHeight: 300,
    based: 850,
    lowQualityThreashold: 696,
    isLowQuality: false,
    imgLoaded: false,
    showPreview: false,
    showPrintPreview: false,
  }),
  mounted() {
    this.$refs.clipper.onChange$.subscribe(() => {
      // This happens whenever zooming, moving and rotating occur.
      //console.log(this.$refs.clipper)
    })
  },
  methods: {
    onDismissed() {
      this.$store.dispatch('clearError')
    },
    imgLoad: function () {
      // const imgRatio = this.$refs.clipper.imgRatio;
      // if (imgRatio < 1) {
      //   this.based = this.maxHeight * imgRatio;
      // } else {
      //   this.based = this.maxWidth;
      // }

      this.imgLoaded = true;
      this.loading = false;

    },
    imgLoadError(error) {
      console.log(error);
    },
    onClipperUploadInput(args) {
      if(args == 'start') {
        this.rotation = 0;
        this.loading = true;
        this.$emit('editing', true);
      }
      console.log('onupload', args);
    },
    handleZoomEvent(scale) {
      console.log('scale', scale);
      this.scale = scale;
      return scale;
    },
    goBack() {
      this.$emit('editing', true)
      this.showPrintPreview = false;
      this.$refs.clipper.setWH$.next(isNaN(this.scale) ? 1 : this.scale) // transform scale(0.6)
    },
    rotate () {
      this.rotation += 45;

      if(this.rotation < -180) {
        this.rotation = 180;
      }
      else if(this.rotation >= 180)
      {
        this.rotation = -180;
      }
    },
    getCroppedImage: function () {
      console.log('start cropping');
      var canvas = this.$refs.clipper.clip(); //call component's clip method  //{maxWPixel:1000}
      var imageData = canvas.toDataURL("image/jpeg", 0.001);//canvas->image
      var croppedImage = {
        width: canvas.width,
        height: canvas.height,
        data: imageData
      }

      console.log('imagequality test cropped image', croppedImage);

      this.isLowQuality = false;

      if (croppedImage.width < this.lowQualityThreashold) {
        this.isLowQuality = true;
        console.log('WARNING: Image to low quality');
      }


      // do it
      canvas = this.$refs.clipper.clip({wPixel:696}); //call component's clip method  //{maxWPixel:1000}
      imageData = canvas.toDataURL("image/jpeg", 1);//canvas->image
      croppedImage = {
        width: canvas.width,
        height: canvas.height,
        data: imageData
      }





      this.resultURL = imageData;
      console.log('final cropped image', croppedImage);

      this.showPrintPreview = true;

      this.$emit('finished', croppedImage)
    },
    // helper function: generate a new file from base64 String
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n) {
        u8arr[n - 1] = bstr.charCodeAt(n - 1)
        n -= 1 // to make eslint happy
      }
      return new File([u8arr], filename, {type: mime})
    },
  }

}
</script>

<style>
.js-overlay-image {
  height: 90% !important;
}

.croppedImage {
  width: 100%;
  max-width: 400px;
  text-align: center;
  margin: auto;
}

.croppedImage img {
  width: 100%;
  /*border-radius: 10px;*/
  /*box-shadow: 0px 0px 20px grey;*/
}
</style>
